"use client";
import { PageNavigation } from "@components/cms/page-navigation/PageNavigation";
import { getCountry } from "@config/site/site-config";
import type { ILinksCollection } from "@contentful-api/types/contentful";
import { useAuth } from "@lib/auth/useAuth";
import { isCountryWithReverseNameOrder } from "@lib/utils/address";
import { useStore } from "@store/index";
import type { PropsWithChildren, ReactNode } from "react";

export type MyAccountLayoutProps = {
    children: ReactNode;
    pageNavigation: ILinksCollection;
};

export const MyAccountLayout = ({
    children,
    pageNavigation,
}: PropsWithChildren<MyAccountLayoutProps>) => {
    const { isLoggedIn } = useAuth();

    const customer = useStore((state) => state.data.me?.customer);

    const firstName = customer?.firstName || "";
    const lastName = customer?.lastName || "";
    const navigationTitle = isCountryWithReverseNameOrder(getCountry)
        ? `${lastName} ${firstName}`.trim()
        : `${firstName} ${lastName}`.trim();

    return (
        <div data-testid="MyAccountPage">
            {pageNavigation && isLoggedIn && (
                <PageNavigation
                    isPrivateDataInTitle
                    pageNavigationLinks={pageNavigation}
                    title={navigationTitle}
                />
            )}
            {children}
        </div>
    );
};
